import axiosInstance from '../utils/axiosInstance';
const API_URL = 'auth';

export const verify = async () => {
  const response = await axiosInstance.get(`${API_URL}/verify`);
  return response.data;
};

export const profile = async () => {
  const response = await axiosInstance.get(`${API_URL}/profile`);
  return response.data;
};

export const changePassword = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/change-password`, data);
  return response.data;
};

export const login = async (User) => {
  const response = await axiosInstance.post(`${API_URL}/login`, User);
  return response.data;
};

export const logout = async () => {
  const response = await axiosInstance.post(`${API_URL}/logout`);
  return response.data;
};

export const inactivityLogout = async () => {
  const response = await axiosInstance.post(`${API_URL}/inactivity-logout`);
  return response.data;
};